import { useTranslation } from "react-i18next";
import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@pracownik/ui";
import { Coins } from "lucide-react";
import { useCredits } from "@/hooks/use-credits";
import { PRICING } from "@pracownik/shared/constants";

export function CreditBadge() {
  const { t } = useTranslation("dashboard");
  const { data: balance, isLoading } = useCredits();

  if (isLoading) {
    return (
      <Badge variant="secondary" className="h-7 px-3">
        <Coins className="size-3.5 opacity-60" />
        <span className="inline-block h-3 w-10 animate-pulse rounded bg-foreground/10" />
      </Badge>
    );
  }

  const b = balance ?? 0;
  const variant = b > 1000 ? "status-success" : b > 200 ? "status-warning" : "status-danger";
  const usd = (b * PRICING.creditValue).toFixed(2);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant={variant} dot className="h-7 cursor-help px-3 text-[13px] tabular">
          {Math.round(b).toLocaleString()} {t("credits.unit")}
        </Badge>
      </TooltipTrigger>
      <TooltipContent side="bottom">{t("credits.tooltip", { usd })}</TooltipContent>
    </Tooltip>
  );
}
